<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <section id="solution" class="bg-[var(--color-bg-primary)] px-5 py-12 md:px-12 md:py-24">
    <div class="mx-auto max-w-[var(--max-w-content)] text-center">
      <h2
        data-reveal
        class="fade-up text-2xl font-medium text-[var(--color-text-primary)] md:text-4xl"
        style="font-family: var(--font-display)"
      >
        {{ t("solution.heading") }}
      </h2>

      <div
        data-reveal
        data-reveal-delay="1"
        class="fade-up mx-auto mt-5 max-w-[600px] space-y-5 text-base leading-[1.7] text-[var(--color-text-secondary)] md:text-lg"
      >
        <p>
          {{ t("solution.p1Before") }}<em>{{ t("solution.p1Em") }}</em
          >{{ t("solution.p1After") }}
        </p>
        <p>
          {{ t("solution.p2Before") }}<em>{{ t("solution.p2Em") }}</em
          >{{ t("solution.p2After") }}
        </p>
      </div>

      <router-link
        data-reveal
        data-reveal-delay="2"
        to="/philosophy"
        class="fade-up mt-6 inline-block text-[15px] font-medium text-[var(--color-primary)] hover:underline"
      >
        {{ t("solution.philosophyLink") }}
      </router-link>
    </div>
  </section>
</template>
